import { useState } from "react";
import { api, getApiBase, setApiBase, getToken, setToken } from "../api/client";
import { useToast, errText } from "../components/ui";

export default function Connection({ onSaved }: { onSaved: () => void }) {
  const notify = useToast();
  const [base, setBase] = useState(getApiBase());
  const [token, setTok] = useState(getToken());

  const save = () => { setApiBase(base); setToken(token); onSaved(); notify({ kind: "ok", msg: "连接已保存" }); };
  const test = async () => {
    setApiBase(base); setToken(token);
    try { await api.health(); notify({ kind: "ok", msg: "连接成功" }); }
    catch (e) { notify({ kind: "error", msg: "连接失败：" + errText(e) }); }
  };

  return (
    <div>
      <div className="panel">
        <div className="panel-head"><span className="title">后端连接</span></div>
        <div className="grid2">
          <div>
            <label>API 基址</label>
            <input value={base} onChange={(e) => setBase(e.target.value)} placeholder="http://127.0.0.1:8787 或 https://quant-api.example.com" />
          </div>
          <div>
            <label>Bearer Token（QUANT_API_TOKEN，可空）</label>
            <input type="password" value={token} onChange={(e) => setTok(e.target.value)} placeholder="留空则后端为开发态开放" />
          </div>
        </div>
        <div style={{ marginTop: 14, display: "flex", gap: 8 }}>
          <button onClick={test}>测试连接</button>
          <button className="primary" onClick={save}>保存</button>
        </div>
      </div>

      <div className="panel">
        <div className="panel-head"><span className="title">说明</span></div>
        <ul className="muted" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.9, fontSize: 13 }}>
          <li>API 地址保存在浏览器本地；访问令牌只保留在当前浏览器会话中，关闭会话后需重新登录。</li>
          <li>生产部署：后端经 Cloudflare Tunnel 暴露为 HTTPS，此处填该地址并设置 Token。</li>
          <li>后端需 <code className="mono">[cta_runner.web] enabled = true</code> 且以 async 引擎运行，才能对「应用变更」做真正的热加载。</li>
        </ul>
      </div>
    </div>
  );
}
